import React, { useEffect, useState } from "react";
import { Container, Spinner } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Controllers } from "@/CommonElements/Controller";
import { useParamFilters } from "@/utils/hooks/useParamFilters";
import { cn, PickKeyPairs } from "@/utils/helpers";
import { AntSelect } from "@/CommonElements/AntSelect";
import { AntInput } from "@/CommonElements/AntInput";
import { ActionsFooter } from "@/Component/ActionsFooter";
import { Button, Stack } from "react-bootstrap";
import { useDepartureReporPreviewtQuery, useDepartureReportMutation, useDepartureReportQuery } from "@/services/reports";
import TableC from "@/CommonElements/TableC";

const DepartureReports = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PageHeader title={t("DEPARTURE_RQUEST_REPORTS")} sticky={false} />
      <Container fluid>
        <DepartureReport />
      </Container>
    </div>
  );
};

export default DepartureReports;

const DepartureReport = () => {
  const form = useForm();
  const { getAllParamFilters } = useParamFilters()
  const { t } = useTranslation()
  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] = useState({})
  
  // ===============
  // Side Effects
  // ===============
  const { mutate: generateDepartureReport, isPending } = useDepartureReportMutation();
  const { data: flightsListRes, isLoading: isFlightsListLoading, isFetching: isFlightsListFetching } = useDepartureReporPreviewtQuery({
    ...filters,
    page: currentPage,
    per_page: 10,
  })
  const reportData = flightsListRes?.data?.data || []
  const meta = flightsListRes?.data?.meta || {}

  useEffect(() => {
    const filters = getAllParamFilters()
    const pickFilters = PickKeyPairs(filters, ["format", "campaign_id"])
    const payload = {
      format: "json",
      ...pickFilters
    }
    form.reset(payload)

  }, [getAllParamFilters])

  const format = form.watch("format");
  const isJson = format === "json";

  const ctrls = [
    {
      labelProps: {
        children: t("REPORT_FORMAT"),
      },
      controllerProps: {
        name: "format",
        render: ({ field }) => (
          <AntSelect
            {...field}
            onChange={(value) => {
              field.onChange(value)
              // setSearchParams({ format: value })
            }}
            placeholder={t("REPORT_FORMAT")}
            options={[
              { value: "pdf", label: t("PDF") },
              { value: "json", label: t("VIEW_REPORTS") },
            ]}
          >
          </AntSelect>
        ),
      }
    },
    {
      labelProps: {
        children: t("CAMPAIGN_NUMBER"),
      },
      controllerProps: {
        rules:{
          required: t("FIELD_REQUIRED"),
        },
        name: "campaign_id",
        render: ({ field }) => (
          <AntInput
            {...field}
            placeholder={t("CAMPAIGN_NUMBER")}
            onChange={(e) => {
              field.onChange(e.target.value)
              // setSearchParams({ campaign_id: e.target.value })
            }}

          >
          </AntInput>
        ),
      }
    },
  ]

  const onsubmit = (data) => {
    const ispdf = data.format === "pdf"
    if (ispdf) {
      setCurrentPage(1)
      generateDepartureReport(data)
    } else {
      setFilters({ ...data })
    }

  }

  const buttonText = {
    pdf: t("EXPORT_PDF"),
    json: t("VIEW_REPORTS"),
  };

  const columns = [
    {
      name: t("PILGRIM_NAME"),
      key: "pilgrim_name",
    },
    {
      name: t("VISA_NUMBER"),
      key: "visa_number",
    },
    {
      name: t("باركود التأشيرة"),
      key: "visa_barcode", // barcode
      render: (value) => value ? <img src={value}></img> : "-",
    },
    {
      name: t("PASSPORT_NUMBER"),
      key: "passport_number",
    },
    {
      name: t("باركود جواز السفر"),
      key: "passport_barcode", // barcode
      render: (value) => value ? <img src={value}></img> : "-",
    },
    {
      name: t("SERVICE_CENTER"),
      key: "service_center_name",
      render: (value) => value || "-",
    },
    {
      name: t("CAMPAIGN_NUMBER"),
      key: "campaign_number",
    },
  ]

  const handlePageChange = (page) => {
    setCurrentPage(page)
    generateDepartureReport({ ...form.getValues(), page: currentPage, per_page: 10 })
  }

  return (
    <Stack>

      <form onSubmit={form.handleSubmit(onsubmit)}>
        <Controllers
          {...{
            controllers: ctrls.map((config) => ({
              ...config,
              labelProps: {
                ...config.labelProps,
                className: cn("fw-bold", config.labelProps.className),
              },
              controllerProps: {
                ...config.controllerProps,
                control: form.control,
                errors: form.errors,
              },
              layout: {
                colProps: { xs: 6, md: 6 },
              },
            })),
          }}
        />

        <ActionsFooter>
          <Button disabled={isPending || isFlightsListFetching} type="submit" className="btn btn-primary">
            {(isPending) ? <Spinner size="sm" /> : null}
            {buttonText[format]}
          </Button>
        </ActionsFooter>
      </form>

      {isJson && <TableC
        data={reportData}
        columns={columns}
        loading={isFlightsListLoading}
        columnsFilter={false}
        pagination={meta ? {
          current: currentPage,
          total: meta?.total || 0,
          pageSize: meta?.per_page || 10,
          onChange: handlePageChange,
        } : undefined}
      />}
    </Stack>
  );
};